import {
  createBrowserRouter,
  Route,
  createRoutesFromElements,
  RouterProvider,
} from "react-router-dom";
import { createContext, useState } from "react";

import { Provider } from "react-redux";
import { store } from "./store/store";
import { ThemeProvider } from "./store/themeProvider";
import exenv from "exenv";
import { setupAxiosInterceptor } from "./helpers/authHelper";
import AuthProvider from "./provider/AuthProvider";
import Routes from "./routes/Routes";
import { Toaster } from "@/components/ui/toaster";

export const ThemeContext = createContext(null);
if (exenv.canUseDOM) {
  // setupAxiosLoaderInterceptor(store.dispatch);
  setupAxiosInterceptor(store.dispatch);
}
// const router = createBrowserRouter(createRoutesFromElements(Routes()));
function App() {
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
    >
      <AuthProvider>
        <Provider store={store}>
          <Routes />
          <Toaster />
        </Provider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
